import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';

import { Button, RadioList } from '@treezor/design-system';

import { useAppSelector, useAppDispatch } from '@/hooks/redux-helpers';

import { setBulkCardCreationStep } from '@/store/actions/bulkCardCreations.actions';

interface IBulkNameForm {
  anonymous: string;
}

export const BulkName = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const activeStep = useAppSelector((state) => state.bulkCardCreation.currentStep);
  const bulkCardCreationDraft = useAppSelector((state) => state.bulkCardCreation.bulkCardCreationDraft);

  const isOptionNoAnonymousDisabled = bulkCardCreationDraft?.createUserForEach;

  const defaultValues: IBulkNameForm = {
    anonymous:
      bulkCardCreationDraft && bulkCardCreationDraft.anonymous === 0 ? bulkCardCreationDraft.anonymous.toString() : '1',
  };

  const { handleSubmit, setValue, watch } = useForm<IBulkNameForm>({ defaultValues });

  const onSubmit = (data: IBulkNameForm) => {
    dispatch(setBulkCardCreationStep(activeStep + 1, { anonymous: Number(data.anonymous) }));
  };

  return (
    <>
      <h5 className="typo-h5-bold text-secondary">{t('pages.administration.bulkCards.bulkname.title')}</h5>
      <form className="flex flex-col gap-6 mt-7 w-[250px]" onSubmit={handleSubmit(onSubmit)}>
        <RadioList
          name="anonymous"
          isDisabled={isOptionNoAnonymousDisabled}
          options={[
            {
              value: '1',
              label: t('pages.administration.bulkCards.bulkname.options.yes.label'),
              hint: t('pages.administration.bulkCards.bulkname.options.yes.description'),
            },
            {
              value: '0',
              label: t('pages.administration.bulkCards.bulkname.options.no.label'),
              hint: t('pages.administration.bulkCards.bulkname.options.no.description'),
            },
          ]}
          onChange={(value) => setValue('anonymous', value)}
          value={watch('anonymous')}
          className="pt-2 gap-3"
        />
        <div className="flex items-center justify-center">
          <Button id="bulk-cards-name-btn" type="submit">
            {t('pages.administration.bulkCards.next')}
          </Button>
        </div>
      </form>
    </>
  );
};
